module.exports = __webpack_public_path__ + "img/116.5.811fca25.png";